import cx from "classnames"
import { ChevronDownIcon } from "../Icon"

type ToggleIconPropsType = { isOpen: boolean; useChevron: boolean }

const ToggleIcon = ({ isOpen, useChevron }: ToggleIconPropsType) => {
  return useChevron ? (
    <ChevronDownIcon
      color="onSurfaceVariant"
      size={24}
      className={cx("cobalt-accordion__header-chevron-icon", {
        "cobalt-accordion__header-chevron-icon--opened": isOpen,
      })}
    />
  ) : (
    <div
      className={cx("cobalt-accordion__header-icon", {
        "cobalt-accordion__header-icon--opened": isOpen,
      })}
    />
  )
}

export default ToggleIcon
